export default /*START_META*/{
  "title": "Customizing Screens",
  "shortTitle": "Screens"
}; /*END_META*/